import { Accordion } from 'components';
import React, { useState } from 'react';
import { FAQContainer, FAQHeader, FAQLink, FAQLinkContainer } from './styled';
import { Show } from 'components/Functional';

interface FAQProps {
  faqContent: { question: string; answer: string }[];
}

export const guaranteeText = `We stand by the products we create and want each and every order to honor
the meaningful in your life. If you are not wholeheartedly satisfied, we will make it right.`;

export const FAQ = ({ faqContent }: FAQProps): JSX.Element => {
  const [activeAccordion, setActiveAccordion] = useState('');

  return (
    <Show when={faqContent?.length > 0}>
      <FAQContainer>
        <FAQHeader>Frequently asked questions</FAQHeader>
        {faqContent?.map(
          (q, i) =>
            q.question && (
              <Accordion
                key={i}
                id={q.question}
                title={q.question}
                content={q.answer}
                active={activeAccordion}
                open={activeAccordion === q.question}
                setActive={setActiveAccordion}
                useNewFonts={true}
              />
            )
        )}
      </FAQContainer>
      <FAQLinkContainer>
        <FAQLink showOnMobile={false}>
          <b>You’ll love it, guaranteed.</b> {guaranteeText}
          <br />
          <a href="https://www.artifactuprising.com/quality">Learn About Our Quality Guarantee</a>
        </FAQLink>
        <FAQLink showOnMobile={false}>
          <b>Still have questions?</b> Find the answers you’re looking for in our help center — alongside our best tips
          and tricks, no matter where you are in the journey.
          <a href="https://help.artifactuprising.com/hc/en-us">Head To Our FAQ Page</a>
        </FAQLink>
        <FAQLink showOnMobile={true}>
          <b>Stuck on a problem?</b> We’re here to help. Our product experts can help answer any question you have, from
          project building to helping with order details. They are just an email away.
          <br />
          <a href="https://help.artifactuprising.com/hc/en-us/requests/new">Contact Our Team</a>
        </FAQLink>
      </FAQLinkContainer>
    </Show>
  );
};
